<template>
  <div>
    <UIExit label="Exit student mode" />
    <router-view></router-view>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import LAYOUT_CONSTANTS from '@src/constants/layout-constant.js'
import UIExit from '@/src/components/UiElements/UIExit.vue'
import { TENANT_ROLES } from '@src/constants/user-roles-constants.js'
import { SCOPE_LEVELS } from '@src/constants/general-constants'
import { getDefaultRoute } from '@src/utils/generalUtil.js'

export default {
  components: {
    UIExit,
  },
  created() {
    this.setLeftBar()
    this.getCampusList()
  },
  page: {
    title: 'Profile | Student',
    meta: [
      {
        name: 'description',
        content: 'Student Profile',
      },
    ],
  },

  methods: {
    /**
     * Exit student mode and redirect to student page
     * Remove current user from localStorage
     */
    setLeftBar() {
      this.setLeftbarContent({
        SHOW_SECTION_DROPDOWN_TO: LAYOUT_CONSTANTS.showSectionDropdownTo,
        SHOW_CLASS_DROPDOWN_TO: LAYOUT_CONSTANTS.showClassDropdownTo,
        back: '',
        customeHeader: 'left-bar-class-list',
        routes: [
          {
            id: '1',
            name: 'Profile',
            icon: 'users',
            route: { name: 'student-profile-mode' },
            role: [TENANT_ROLES.SUPER_ADMIN, , TENANT_ROLES.SECTION_TEACHER],
          },
          {
            id: '4',
            icon: 'attendance',
            name: 'ATTENDANCE',
            role: [
              TENANT_ROLES.SUPER_ADMIN,
              TENANT_ROLES.SECTION_TEACHER,
              TENANT_ROLES.SECTION_STUDENT,
            ],
            showChilds: false,
            basedOn: [
              SCOPE_LEVELS.CAMPUS_LEVEL,
              SCOPE_LEVELS.CLASS_LEVEL,
              SCOPE_LEVELS.SECTION_LEVEL,
            ],
            route: { name: 'student-view-campus-attendance' },
            routesName: [
              'student-view-campus-attendance',
              'student-view-section-attendance',
              'student-view-period-attendance',
            ],
            childs: [
              {
                name: 'STUDENTS_CAMPUS_ATTENDANCE',
                route: { name: 'student-view-campus-attendance' },
                basedOn: [
                  SCOPE_LEVELS.CAMPUS_LEVEL,
                  SCOPE_LEVELS.CLASS_LEVEL,
                  SCOPE_LEVELS.SECTION_LEVEL,
                ],
              },
              {
                name: 'STUDENTS_PERIOD_ATTENDANCE',
                route: { name: 'student-view-period-attendance' },
                basedOn: [SCOPE_LEVELS.SECTION_LEVEL],
              },
              {
                name: 'STUDENTS_SECTION_ATTENDANCE',
                route: { name: 'student-view-section-attendance' },
                basedOn: [SCOPE_LEVELS.CLASS_LEVEL, SCOPE_LEVELS.SECTION_LEVEL],
              },
            ],
          },
          {
            id: '003',
            icon: 'expenseManager',
            name: 'Fees',
            role: [
              TENANT_ROLES.SUPER_ADMIN,
              TENANT_ROLES.SECTION_TEACHER,
              TENANT_ROLES.CAMPUS_ADMIN,
            ],
            basedOn: [
              SCOPE_LEVELS.CAMPUS_LEVEL,
              SCOPE_LEVELS.CLASS_LEVEL,
              SCOPE_LEVELS.SECTION_LEVEL,
            ],
            route: { name: 'student-fee-receivable' },
            showChilds: false,
            routesName: ['student-fee-receivable', 'student-fee-received'],
            childs: [
              {
                name: 'STUDENT_PAYABLE',
                route: { name: 'student-fee-receivable' },
                role: [
                  TENANT_ROLES.SUPER_ADMIN,
                  TENANT_ROLES.SECTION_TEACHER,
                  TENANT_ROLES.CAMPUS_ADMIN,
                ],
              },
              {
                name: 'STUDENT_PAID',
                route: { name: 'student-fee-received' },
                role: [
                  TENANT_ROLES.SUPER_ADMIN,
                  TENANT_ROLES.SECTION_TEACHER,
                  TENANT_ROLES.CAMPUS_ADMIN,
                ],
              },
            ],
          },
          {
            id: '007',
            name: 'TIME_TABLE',
            icon: 'timeTable',
            basedOn: [SCOPE_LEVELS.SECTION_LEVEL],
            role: [
              TENANT_ROLES.SUPER_ADMIN,
              TENANT_ROLES.SECTION_TEACHER,
              TENANT_ROLES.CAMPUS_ADMIN,
            ],
            route: { name: 'student-current-time-table' },

            showChilds: false,
            routesName: ['student-current-time-table'],
            childs: [
              {
                name: 'CURRENT_TIME_TABLE',
                route: { name: 'student-current-time-table' },
                basedOn: [SCOPE_LEVELS.SECTION_LEVEL],
              },
            ],
          },
          {
            id: '004',
            icon: 'examPlanner',
            name: 'Exams',
            role: [
              TENANT_ROLES.SUPER_ADMIN,
              TENANT_ROLES.SECTION_TEACHER,
              TENANT_ROLES.CAMPUS_ADMIN,
            ],
            basedOn: [SCOPE_LEVELS.CLASS_LEVEL, SCOPE_LEVELS.SECTION_LEVEL],
            route: { name: 'student-exam-view' },
            showChilds: false,
            routesName: [
              'student-exam-view',
              'student-exams-detail-view',
              'exam-result-view',
              'student-subject-result',
              'student-subject-result-detail',
              'student-subject-result-view',
              'student-final-result',
              'student-final-result-detail',
              'student-final-result-view',
              'student-performance-result',
            ],
            childs: [
              {
                name: 'Exam',
                route: { name: 'student-exam-view' },
                role: [
                  TENANT_ROLES.SUPER_ADMIN,
                  TENANT_ROLES.CAMPUS_ADMIN,
                  TENANT_ROLES.SECTION_TEACHER,
                ],
              },
              {
                name: 'Student Exam Details',
                route: { name: 'student-exams-detail-view' },
                isDynamicRoute: true,
              },
              {
                name: 'SUBJECT_RESULT',
                route: { name: 'student-subject-result' },
              },
              {
                name: 'Subject Result detail',
                route: { name: 'student-subject-result-detail' },
                isDynamicRoute: true,
              },
              {
                name: 'Subject Result View',
                route: { name: 'student-subject-result-view' },
                isDynamicRoute: true,
              },
              {
                name: 'FINAL_RESULT',
                route: { name: 'student-final-result' },
              },
              {
                name: 'STUDENT_PERFORMANCE',
                route: { name: 'student-performance-result' },
              },
              {
                name: 'Section Exams Result detail',
                route: { name: 'student-final-result-detail' },
                isDynamicRoute: true,
              },
              {
                name: 'Student Result detail',
                route: { name: 'student-final-result-view' },
                isDynamicRoute: true,
              },
            ],
          },
          {
            id: '005',
            icon: 'lessonPlanner',
            name: 'SYLLABUS_MANAGER',
            role: [
              TENANT_ROLES.SUPER_ADMIN,
              TENANT_ROLES.CAMPUS_ADMIN,
              TENANT_ROLES.SECTION_TEACHER,
            ],
            basedOn: [SCOPE_LEVELS.CLASS_LEVEL, SCOPE_LEVELS.SECTION_LEVEL],
            route: { name: 'student-syllabus' },
            showChilds: false,
            routesName: [
              'student-lessons',
              'student-topics',
              'student-chapters',
              'student-subjects',
            ],
            childs: [
              {
                name: 'SUBJECTS',
                route: { name: 'student-subjects' },
              },
              {
                name: 'Chapters',
                route: { name: 'student-chapters' },
              },
              {
                name: 'TOPICS',
                route: { name: 'student-topics' },
              },
              {
                name: 'Lessons',
                route: { name: 'student-lessons' },
              },
            ],
          },
        ],
      })
    },
    ...mapActions('layout', ['setLeftbarContent', 'getCampusList']),
  },
}
</script>
